/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function startCountdown() {
    // Set initial time (in minutes and seconds)
    let minutes = 9;
    let seconds = 55;
    
    function updateCountdown() {
        // Decrease seconds
        seconds--;
        
        // If seconds reach below 0, decrease minutes and reset seconds to 59
        if (seconds < 0) {
            seconds = 59;
            minutes--;
        }
        
        // If both minutes and seconds reach 0, reset to 09:55
        if (minutes < 0) {
            minutes = 9;
            seconds = 55;
        }
        
        // Add leading zeros if needed
        let displayMinutes = minutes < 10 ? '0' + minutes : minutes;
        let displaySeconds = seconds < 10 ? '0' + seconds : seconds;
        
        // Display the countdown
        document.getElementById('timeDisplay').textContent = `${displayMinutes}:${displaySeconds}`;
    }
    
    // Update the countdown every second
    setInterval(updateCountdown, 1000);
}

// Start the countdown
startCountdown();


/** New Code **/

document.addEventListener('DOMContentLoaded', function () {
    // Define the product variant IDs for the add-ons
    const addons = [
        { productId: 45435168686292, quantity: 1 }, // Damage Protection
        { productId: 45805394493652, quantity: 1 }, // Loss Protection
        { productId: 45805395149012, quantity: 1 }  // Theft Protection
    ];

    // Define the main product ID
    const mainProductId = 8670841831649; // Replace with your actual main product ID

    // Function to check if a product already exists in the cart
    function checkIfProductExistsInCart(productId) {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                return cart.items.some(item => item.id === productId);
            })
            .catch(error => {
                console.error('Error fetching cart contents:', error);
                return false; // Default to false if there's an error
            });
    }

    // Function to get all products in the cart
    function getCartContents() {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => cart.items)
            .catch(error => {
                console.error('Error fetching cart contents:', error);
                return [];
            });
    }




  
    // Function to add products to the cart
    function addProductToCart(productId, quantity) {
        return fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: productId,
                quantity: quantity // Quantity can be adjusted if necessary
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
              console.log(`Added product ${productId} to the cart.`);  
        })
        .catch(error => {
            console.error('Error adding product to the cart:', error);
        });
    }


    // Function to remove products from the cart
    function removeProductFromCart(productId) {
        return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: productId,
                quantity: 0 // Set quantity to 0 to remove the product
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            console.log(`Removed product ${productId} from the cart.`);
        })
        .catch(error => {
            console.error('Error removing product from the cart:', error);
        });
    }

  
    // Add add-ons sequentially
    function addAddonsSequentially(addons) {
        let sequence = Promise.resolve();

        addons.forEach(addon => {
            sequence = sequence.then(() => {
                return checkIfProductExistsInCart(addon.productId).then(exists => {
                    if (!exists) {
                        return addProductToCart(addon.productId, addon.quantity);
                    } else {
                        console.log(`Product ${addon.productId} already exists in the cart. Skipping.`);
                    }
                });
            });
        });
        jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").addClass("load-data");
        sequence.then(() => {
                $("#halo-cart-sidebar .halo-sidebar-wrapper").load("/cart?view=ajax_side_cart", function() {
                    console.log('All eligible add-ons have been added to the cart.');
                    $(".previewCart").css("overflow-y", "auto");
                    $(".previewCart").css("overflow-x", "hidden");
                });
                
               
              
        });
    }
  
  
    // Function to check if any add-ons exist in the cart and remove them if none exist
    function checkForAddonsAndRemoveIfNone() {
        getCartContents().then(cartItems => {
            const addonIds = addons.map(addon => addon.productId);
            const anyAddonExists = cartItems.some(item => addonIds.includes(item.id));

            if (!anyAddonExists) {
                console.log('No add-on products found in the cart. Removing all add-ons.');
                addons.forEach(addon => {
                    removeProductFromCart(addon.productId);
                });
            } else {
                console.log('At least one add-on product exists in the cart. No removals necessary.');
            }
        });
    }

$(document).on('click', '#product-add-to-cart', function() {
    console.log('Add to Cart button clicked. Adding main product first...');
    addProductToCart(mainProductId, 1).then(() => {
        console.log('Main product added. Now managing add-ons...');
        manageAddonsBasedOnCart();
    });
});


    // Function to remove a product from the cart using XMLHttpRequest
    function removeFromCartJS(variantID) {
    
      console.log($.isNumeric(variantID));
       console.log(variantID);
      
        return new Promise((resolve, reject) => {
            var xhr = new XMLHttpRequest(),
                url = "/cart/change.js";
            xhr.open("POST", url, true);
            xhr.setRequestHeader("Content-Type", "application/json");
            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                      
                        var parsedState = JSON.parse(xhr.responseText);
                      
                        document.dispatchEvent(new Event('cart:updated')); 
                        console.log("Cart refreshed from remove function");
                      
                        resolve(parsedState);
                    } else {
                        reject(xhr.statusText);
                    }
                }
            };
            var data = JSON.stringify({
                quantity: 0, // Setting quantity to 0 removes the item
                id: variantID
            });
            xhr.send(data);
        });
    }


  document.addEventListener('click', function(event) {
    if (event.target.classList.contains('addon-remove-from-cart')) {
        event.preventDefault();  // Prevent default action (e.g., form submit or link navigation)
        const variantID = event.target.dataset.pid;  // Get the variant ID from the data attribute
        
        // Check if variantID is available
        if (!variantID) {
            console.error("No variant ID found in the button's data-pid attribute.");
            return;
        }
        console.log(`Removing product with variant ID: ${variantID}`);  // Debugging log

        jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").addClass("load-data");
        // Attempt to remove the product
        removeFromCartJS(variantID)
            .then(() => {
                $("#halo-cart-sidebar .halo-sidebar-wrapper").load("/cart?view=ajax_side_cart", function() {
                    console.log(`Product with variant ID ${variantID} removed from cart.`);
                    $(".previewCart").css("overflow-y", "auto");
                    $(".previewCart").css("overflow-x", "hidden");
                });
            })
            .catch((error) => {
                console.error("Error removing product from cart:", error);
            });
    }
}); 


const addOnData = {
    "loss-protection": {
        title: "Loss Protection",
        price: "$30.00",
        image: "https://cdn.shopify.com/s/files/1/0656/0130/6836/files/Artboard_12_4x_affe93b6-3483-4cd0-9701-33dc26c815c1.png?v=1730890581",
        description: "Safeguard your order from loss during shipping.",
        pid: "45805394493652"
    },
    "damage-protection": {
        title: "Damage Protection",
        price: "$100.00",
        image: "https://cdn.shopify.com/s/files/1/0656/0130/6836/files/Artboard_11_4x_b78d0234-0945-4ded-bdc1-246dd94eaa60.png?v=1730890581",
        description: "Protect your order from shipping damage.",
        pid: "45435168686292"
    },
    "theft-protection": {
        title: "Theft Protection",
        price: "$20.00",
        image: "https://cdn.shopify.com/s/files/1/0656/0130/6836/files/Artboard_10_4x_704620bf-b99c-4429-8967-0d8b4827719b.png?v=1730890581",
        description: "Protect your purchase from theft during shipping.",
        pid: "45805395149012"
    }
};

    

// Use event delegation for dynamically loaded elements
    document.body.addEventListener('click', event => {
        if (event.target.classList.contains('addon-icon')) {
            event.preventDefault();
            const icon = event.target;  // Get the clicked icon element
            const addonType = icon.getAttribute("data-addontype");  // Get the addon type

            const addonInfo = addOnData[addonType];
          
            // Ensure addon data is valid before proceeding
            if (!addonInfo) {
                console.error(`No addon data found for type: ${addonType}`);
                return;
            }

            // Log for debugging
            console.log(`Addon clicked: ${addonInfo.title}`);
            
            // Update the addon information on the page
            document.querySelector(".addon-title").textContent = addonInfo.title;
            document.querySelector(".addon-price").textContent = addonInfo.price;
            document.querySelector(".addon-description").textContent = addonInfo.description;
            document.querySelector(".addon-image").setAttribute("src", addonInfo.image);

            // Fetch the current cart data to update the UI accordingly
            fetch("/cart.js")
                .then(response => response.json())
                .then(cart => {
                    const existingItem = cart.items.find(item => item.variant_id == +addonInfo.pid);

                    // Reset both buttons first
                    document.querySelector(".addon-remove-from-cart").setAttribute("data-pid", "");
                    document.querySelector(".addon-add-to-cart").setAttribute("data-pid", "");

                    // Check if the item exists in the cart and adjust UI accordingly
                    if (existingItem && existingItem.quantity >= 1) {
                        document.querySelector(".addon-add-to-cart").classList.add("hidden");
                        document.querySelector(".addon-remove-from-cart").classList.remove("hidden");
                        document.querySelector(".addon-remove-from-cart").setAttribute("data-pid", addonInfo.pid);
                    } else {
                        document.querySelector(".addon-add-to-cart").classList.remove("hidden");
                        document.querySelector(".addon-add-to-cart").setAttribute("data-pid", addonInfo.pid);
                        document.querySelector(".addon-remove-from-cart").classList.add("hidden");
                    }
                })
                .catch(error => {
                    console.error('Error fetching cart data:', error);
                });

            // Show the addon info panel
            document.getElementById("addon-info-panel").classList.add("active");
            jQuery("#addon-info-panel").css('display','block');
        }
    });  



// Consider adding a touch event as well for better responsiveness on iOS
document.body.addEventListener('touchstart', event => {
    if (event.target.classList.contains('addon-icon')) {
        event.preventDefault();
        event.target.click(); // Trigger the click event
    }
});

  
  
 // Function to manage add-ons based on cart contents
    function manageAddonsBasedOnCart() {
        getCartContents().then(cartItems => {
            const totalItems = cartItems.length;

            // If total items are 4 or more, remove all add-ons
            if (totalItems >= 4) {
                console.log('Cart has 4 or more items. Removing all add-ons.');
                addons.forEach(addon => {
                    removeProductFromCart(addon.productId);
                });
            } else {
                console.log('Less than 4 items in the cart. Adding add-ons if necessary.');
                addAddonsSequentially(addons);
            }
        });
    }

  jQuery(document).on('click', '.close', function(){
       jQuery("#addon-info-panel").css('display','none');
  });

  jQuery(document).on('click', '#halo-cart-sidebar .plus.btn-quantity', function(){
          jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").addClass("load-data");
          setTimeout(() => {
            jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").load("/cart?view=ajax_side_cart", function() {
                     console.log(`Cart Updated One product Added.`);
                     jQuery(".previewCart").css("overflow-y", "auto");
                     jQuery(".previewCart").css("overflow-x", "hidden");
             });
           }, 1000);
  });

  jQuery(document).on('click', '#halo-cart-sidebar .minus.btn-quantity', function(){
            jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").addClass("load-data");
               setTimeout(() => {
                 
                        jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").load("/cart?view=ajax_side_cart", function() {
                        jQuery(".previewCart").css("overflow-y", "auto");
                        jQuery(".previewCart").css("overflow-x", "hidden");
                 });
                }, 1000);
  });



  

  function customAddToCartJS(variantID, qty = 1) {
  
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            fetch("/cart.js").then(response => response.json()).then(cart => {
                const existingItem = cart.items.find(item => item.variant_id === variantID);
                if (existingItem && existingItem.quantity >= 1) console.log("Product already in cart with quantity 1 or more. No further increase allowed."), resolve();
                else {
                    var xhr = new XMLHttpRequest,
                        url = "/cart/add.js";
                    xhr.open("POST", url, !0), xhr.setRequestHeader("Content-Type", "application/json"), xhr.onreadystatechange = function() {
                        if (xhr.readyState === 4)
                            if (xhr.status === 200) {
                                var parsedState = JSON.parse(xhr.responseText);
                                   
                                    jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").addClass("load-data");
                                   
                                    jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").load("/cart?view=ajax_side_cart", function() {
                                          console.log(`Product with variant ID ${variantID} added to cart.`);
                                          jQuery(".previewCart").css("overflow-y", "auto");
                                          jQuery(".previewCart").css("overflow-x", "hidden");
                                    });
                              
                            } else reject(xhr.statusText)
                    };
                    var data = JSON.stringify({
                        quantity: qty,
                        id: variantID
                    });
                    xhr.send(data)
                }
            }).catch(error => reject(error))
        }, 1e3)
    })
}
   

  // Function to handle adding the product to the cart when the button is clicked
// Attach the listener dynamically when the button is clicked
jQuery(document).on('click', '.addon-add-to-cart', function(event) {
    event.preventDefault(); // Prevent the default behavior of the click

    const addToCartBtn = event.target; // The clicked button
    const variantID = addToCartBtn.getAttribute("data-pid"); // Get the variant ID
    const quantity = 1; // Default quantity

    const handleAddToCart = async () => {
        try {
            // Disable the button to prevent multiple clicks
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = "Adding..."; // Change button text

            // Call the custom function to add the product to the cart
            await customAddToCartJS(variantID, quantity);

            // Optionally, provide feedback to the user (e.g., show success message)
            console.log(`Product with variant ID ${variantID} added to cart.`);

            // Re-enable the button after the product is added
            addToCartBtn.textContent = "Add to Cart"; // Reset button text
            addToCartBtn.disabled = false;
        } catch (error) {
            console.error("Error adding product to cart:", error);
            alert("Failed to add product to cart. Please try again."); // Error feedback
            addToCartBtn.textContent = "Add to Cart"; // Reset button text
            addToCartBtn.disabled = false; // Re-enable the button on error
        }
    };

    // Call the function immediately
    handleAddToCart();
});






// Function to get the cart state
function getCartState() {
    return new Promise((resolve, reject) => {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", "/cart.js", true);
        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var cartState = JSON.parse(xhr.responseText);
                    resolve(cartState);
                } else {
                    reject(xhr.statusText);
                }
            }
        };
        xhr.send();
    });
}

// Function to remove item from cart by variant ID
function removeFromCartJSTWO(variantID) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',  // Update this URL based on your platform
            data: {
                id: variantID,
                quantity: 0
            },
            dataType: 'json',
            success: function(response) {
                resolve(response);
            },
            error: function(error) {
                reject(error);
            }
        });
    });
}

// Function to remove add-ons sequentially
function removeAddonsSequentially(addons, index = 0) {
    // Check if we have finished removing all add-ons
    if (index >= addons.length) {
        console.log("All specified add-ons have been removed.");
          jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").addClass("load-data");
          setTimeout(() => {
               jQuery("#halo-cart-sidebar .halo-sidebar-wrapper").load("/cart?view=ajax_side_cart", function() {
                       console.log(`Cart Updated One product Removed.`);
                       jQuery(".previewCart").css("overflow-y", "auto");
                       jQuery(".previewCart").css("overflow-x", "hidden");
               });
            }, 1000);
            return;
    }

    // Get the current add-on
    const addon = addons[index];

    // Get the current cart state to see if the add-on exists in the cart
    getCartState().then(cartState => {
        const item = cartState.items.find(cartItem => parseInt(cartItem.id, 10) === addon.productId);

        // If the add-on is in the cart, remove it
        if (item) {
            const variantID = addon.productId;
            removeFromCartJSTWO(variantID)
                .then(() => {
                    console.log(`Addon with product ID ${variantID} removed.`);
                    // Recursively call the function for the next add-on
                    removeAddonsSequentially(addons, index + 1);
                })
                .catch(error => {
                    console.error("Error removing addon:", error);
                });
        } else {
            // If the add-on is not found, continue with the next one
            removeAddonsSequentially(addons, index + 1);
        }
    }).catch(error => {
        console.error("Error fetching cart state:", error);
    });
}

// Function to check if cart has exactly 4 items and then remove add-ons
function checkCartAndRemoveAddons() {
    getCartState().then(cartState => {
        if (cartState.items.length === 4) {
            removeAddonsSequentially(addons);
        } else {
            console.log(`Cart has ${cartState.items.length} items. No action taken.`);
        }
    }).catch(error => {
        console.error("Error fetching cart state:", error);
    });
}

// Bind the click event to remove items on click only if the cart has 4 items
jQuery(document).on('click', '.previewCartItem-remove', function() {
    checkCartAndRemoveAddons();
});


  
  
});

 
